import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    (async () => {
      if (!sid) { navigate("/"); return; }
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: r.data } });
      } catch {
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" style={{ background: "var(--mfp-bg)" }}>
      <Loader2 className="w-8 h-8 text-[#FF334B] spin" />
      <p className="mono-label">Iniciando sesión…</p>
    </div>
  );
}
